import { isString as lodashIsString } from "lodash";

const isString = lodashIsString;

export default {
  isString
};
